'use client';

import React from 'react';
import { cn } from './cn';

export type SkeletonLinesProps = {
  show: boolean;
  /** CSS shape suffix: `skeleton-${shape}` (see `styles/skeleton/ui-skeleton.css`). */
  shape: string;
  /** How many `.skeleton.skeleton-${shape}` nodes to render (paragraph uses 4 for nth rules). */
  lines: number;
  children: React.ReactNode;
};

/** Renders stacked skeleton lines or real content. */
export function SkeletonLines({ show, shape, lines, children }: SkeletonLinesProps) {
  const shapeClass = `skeleton-${shape}`;
  if (!show) return <>{children}</>;
  return (
    <>
      {Array.from({ length: lines }, (_, i) => (
        <span key={i} className={cn('skeleton', shapeClass)} aria-hidden />
      ))}
    </>
  );
}
